import InquiryDetail from './inquiry_detail'
import requireAuth from '../../require-auth'

export default requireAuth(InquiryDetail)



// WEBPACK FOOTER //
// ./src/components/pages/inquiry_detail/index.ts